import { privateAxios } from '@/services/api'

export const _getAllSchedules = () => {
    return privateAxios.get('/schedules')
        .then(response => response.data)
}

export const _getSchedules = (data) => {
    return privateAxios.post('/schedules/search', data)
        .then(response => response.data)
}

export const _getSchedule = (id) => {
    return privateAxios.get(`/schedules/${id}`)
        .then(response => response.data)
}

export const _addSchedule = (data) => {
    return privateAxios.post('/schedules', data)
        .then(response => response.data)
}

export const _updateSchedule = (data) => {
    return privateAxios.put('/schedules', data)
        .then(response => response.data)
}

export const _deleteSchedule = (id) => {
    return privateAxios.delete(`/schedules/${id}`)
        .then(response => response.data)
}
